import { B1, P2, Tooltip, Radio, CheckBox, Row,P3 , P1, LabelValueWeb, LabelValueMobile} from 'pfm-ui-components';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import AxisSelectTag from '../../mutualFund/explorePage/ExploreFundCard/AxisSelectTag';
import { HorizontalLine } from '../../../common/HorizontalLine';
import { pxToRem } from '../../../../styles/utils';
import * as constants from '../../../../constants/investTransactPage';
import { checkBoxStyling } from '../../../../styles/common';
import RiskIcon from '../../../../assets/icons/info.svg';
import { getDateinMonthDateYearFormat, uiDateFormat } from '../../../../utils/date';
import { getAMCImage } from '../../schemeDetail/util';
import { formatNavValue } from '../../../../utils/calculations';
import { useDeviceType } from '../../../../utils/deviceType';
import DEVICE_TYPE from '../../../../constants/device';
import { AXIS_BANK_MEANING_MESSAGE, SCHEME_RISK_DESCRIPTION } from '../../../../constants/common';
import { FundOption } from '../../../../pages/transact/invest';

interface InvestSchemeDetailCardProps {
  formik: any;
  onChange: Function;
  fundName: string;
  isAxisSelect: boolean;
  isNfo: boolean;
  dividendOptions: Array<string>;
  latestNavDate: string;
  latestNav: number;
  fundRiskProfile: string;
  fundHouseId: string;
  onOpenDetails?: Function;
  hasAlreadyInvested: boolean;
  changeFundOption: Function;
  fundOptions: Array<FundOption>;
  buyDetailsLoading: boolean;
  fundCodeOptionSelected: string;
}

export default function InvestSchemeDetailCard(props: InvestSchemeDetailCardProps) {
  const {
    formik,
    onChange,
    dividendOptions,
    fundName,
    isAxisSelect,
    isNfo,
    latestNav,
    latestNavDate,
    fundRiskProfile,
    fundHouseId,
    onOpenDetails,
    fundOptions,
    hasAlreadyInvested,
    changeFundOption,
    buyDetailsLoading,
    fundCodeOptionSelected,
  } = props;
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;
  return (
    <InvestSchemeDetailCardWrapper>
      <HeaderWrapper>
        <ImageStyled src={`/images/amc/${getAMCImage(fundHouseId)}`}></ImageStyled>

        <HeadingWrapper>
          <StyledB1 onClick={onOpenDetails}>{fundName}</StyledB1>
          <LabelIconsWrapper>
            <TooltipWrapper enable={true}>
              <Tooltip
                content={<StyledP2>{SCHEME_RISK_DESCRIPTION[fundRiskProfile.toUpperCase()]}</StyledP2>}
                className="tooltipStyle"
              >
                <HighlightedRiskLabel>{`${fundRiskProfile.toUpperCase()} RISK`} </HighlightedRiskLabel>
              </Tooltip>
            </TooltipWrapper>
            <TooltipWrapper enable={isAxisSelect} addTopMargin={true}>
              <Tooltip content={<StyledP2>{AXIS_BANK_MEANING_MESSAGE}</StyledP2>} className="tooltipStyle">
                <AxisSelectTag />
              </Tooltip>
            </TooltipWrapper>

          </LabelIconsWrapper>

          <BodyWrapper>
            {/* <Wrapper> */}
            {/* <CheckBoxGroupWrapper>
            {hasAlreadyInvested ? (
              <CheckBoxWrapper enable={true}>
                <StyledCheckBox
                  label={formik.values.growthOrDividendOption}
                  name="dividendOption"
                  labelColor="#4A4A4A"
                  checkBoxStyling={checkBoxStyling}
                  checked={true}
                  // onChange={() => onChange('growthOrDividendOption', constants.GROWTH)}
                />
              </CheckBoxWrapper>
            ) : (
              (fundOptions || []).map((fundOption: FundOption, index) => (
                <CheckBoxWrapper enable={true} key={`fund-option-${index}`}>
                  <StyledCheckBox
                    label={fundOption.planType}
                    name="dividendOption"
                    labelColor="#4A4A4A"
                    checkBoxStyling={checkBoxStyling}
                    checked={fundCodeOptionSelected === fundOption.fundId}
                    onChange={() => {
                      onChange('growthOrDividendOption', fundOption.planType);
                      changeFundOption(fundOption.fundId);
                    }}
                  />
                </CheckBoxWrapper>
              ))
            )}
          </CheckBoxGroupWrapper> */}
            {!buyDetailsLoading && (
              <DividendOptionsWrapper disable={formik?.values?.growthOrDividendOption === constants.GROWTH}>
                <RadioGroupWrapper>
                  <StyledRadio
                    label={constants.PAYOUT}
                    className="statement-page-radio"
                    checked={formik.values.dividendOption === constants.PAYOUT}
                    onChange={() => onChange('dividendOption', constants.PAYOUT)}
                  />
                  <StyledRadio
                    label={constants.REINVESTMENT}
                    className="statement-page-radio"
                    checked={formik?.values?.dividendOption === 'Re-Investment'}
                    onChange={() => onChange('dividendOption', 'Re-Investment')}
                  />
                </RadioGroupWrapper>
              </DividendOptionsWrapper>
            )}
            {/* </Wrapper> */}

            {!buyDetailsLoading && !isNfo && (
              <div>
                {isMobile ? (
                  <MobileNAVWrapper>
                    <P1 style={{ color: '#6d6e71', fontSize: '13px', fontWeight: 'bold' }}>NAV</P1>
                    <StyledLabelValueMobile
                      label={`as on ${getDateinMonthDateYearFormat(uiDateFormat(latestNavDate))}`}
                      values={`₹ ${latestNav && formatNavValue(latestNav?.toString())}`}
                    />
                  </MobileNAVWrapper>
                ) : (
                  null
                )}
              </div>
            )}
          </BodyWrapper>
          
          
        </HeadingWrapper>
        {!buyDetailsLoading && !isNfo && (
            <>
                {isMobile ? (
                  null
                ) : (
                  <NAVWrapper >
                    <P3 style={{ color: '#6d6e71', fontSize: '13px',  fontWeight: 'bold', marginLeft: '5px' }}>NAV</P3>
                    <LabelValueWeb
                     values={`as on ${getDateinMonthDateYearFormat(uiDateFormat(latestNavDate))}`}
                      label= {`₹ ${latestNav && formatNavValue(latestNav?.toString())}`} 
                    />
                  </NAVWrapper>
                )}
             
             </>
               )}
      </HeaderWrapper>
      {/* <HorizontalLine />   */}
    </InvestSchemeDetailCardWrapper>
  );
}

const InvestSchemeDetailCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${up('md')} {
    height: ${pxToRem(100)};
  }
`;

const HeaderWrapper = styled.article`
  display: flex;
  justify-content: flex-start;

  padding: ${pxToRem(12)} ${pxToRem(6)};
  padding-right: 0;
  ${up('md')} {
    padding: ${pxToRem(24)};
  }
`;

const StyledRiskIcon = styled(RiskIcon)`
  width: ${pxToRem(40)};
`;

const HeadingWrapper = styled.article`
  display: flex;
  flex-direction: column;
  padding-left: ${pxToRem(8)};
  ${up('md')} {
    padding-left: ${pxToRem(24)};
  }
`;

const LabelIconsWrapper = styled.article`
  display: flex;
  flex-direction: column;
  ${up('md')} {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const BodyWrapper = styled.article`
  display: flex;
  flex-direction: column;
  padding: ${pxToRem(12)};
  ${up('md')} {
    padding: ${pxToRem(24)};
    flex-direction: row;
    justify-content: space-between;
  }
`;

const CheckBoxGroupWrapper = styled.article`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-bottom: ${pxToRem(12)};
  flex: 1;
  ${up('md')} {
    // width: 30%;
    padding-bottom: 0;
  }
`;

const CheckBoxWrapper = styled.article<{ enable: boolean }>`
  display: ${(props) => (props.enable ? 'inline-block' : 'none')};
  margin-bottom: ${pxToRem(8)};
`;

const StyledCheckBox = styled(CheckBox)`
  margin-right: ${pxToRem(8)};
  max-height: ${pxToRem(72)};
  ${up('md')} {
    padding: 0 ${pxToRem(8)};
    min-height: ${pxToRem(56)};
    margin-right: ${pxToRem(16)};
    min-width: ${pxToRem(136)};
  }
`;

const StyledRow = styled(Row) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
  margin: 0;
`;
const NAVWrapper = styled.article`
  //background-color: #f6f7f8;
  border-radius: ${pxToRem(8)};
  width: ${pxToRem(120)};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  //margin-top: ${pxToRem(-90)};
  ${up('md')} {
    // width: ${pxToRem(100)};
      margin-top: ${pxToRem(-8)};
     margin-left: auto;
  }
`;

const MobileNAVWrapper = styled.article`
//background-color: #f6f7f8;
border-radius: ${pxToRem(8)};
//width: 350px;
padding: 0.5rem;
//margin-top: ${pxToRem(-90)};
margin-left: -58.5px;
outline: 1px solid #BAB9B9;
height: 50px;
${up('md')} {
 // width: ${pxToRem(200)};
   margin-top: ${pxToRem(-90)};
   //margin-right:${pxToRem(20)};
}
`;

const StyledB1 = styled(B1)`
  color: #4a4a4a;
  padding: 0 ${pxToRem(4)} ${pxToRem(4)} ${pxToRem(4)};
  ${up('md')} {
    :hover {
      font-weight: bolder;
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

const StyledLabelValueMobile = styled(LabelValueMobile)`
  //padding-bottom: ${pxToRem(20)};
  
  ${up('md')} {
    padding-bottom: 0;
  }
  .values {
    margin-left:200px;
  }
`;

const AxisSelectBankWrapper = styled.article<{ enable: boolean }>`
  display: ${(props) => (props.enable ? 'inline-block' : 'none')};
  margin-right: ${pxToRem(8)};
`;

const HighlightedRiskLabel = styled(P2)`
  font-weight: normal;
  background-color: #f6f7f8;
  border-radius: ${pxToRem(12)};
  color: #6d6e71;
  padding: ${pxToRem(2)} ${pxToRem(8)};
  width: fit-content;
  cursor: pointer;
  margin-top: ${pxToRem(8)};
  ${up('md')} {
    margin-top: 0;
  }
`;

const DividendOptionsWrapper = styled.article<{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : 'flex')};
  // padding: ${pxToRem(4)} 0;
  // ${up('md')} {
  //   padding-top: ${pxToRem(26)};
  // }
`;

const RadioGroupWrapper = styled.article`
  display: flex;
  padding-bottom: ${pxToRem(12)};
  ${up('md')} {
    padding-bottom: 0;
  }
`;

const StyledRadio = styled(Radio)`
  &.statement-page-radio {
    font-weight: normal;
    color: ${(props) => props.theme.palette.black3};
  }
  padding: 0 ${pxToRem(32)} 0 ${pxToRem(4)};
  ${up('md')} {
    padding-right: ${pxToRem(16)};
  }
`;

const StyledP2 = styled(P2)`
  color: ${(props) => props.theme.palette.grey2};
`;

const TooltipWrapper = styled.div<{ enable: boolean; addTopMargin?: boolean }>`
  display: ${(props) => (props.enable ? 'inline-block' : 'none')};
  margin-right: ${pxToRem(8)};
  margin-top: ${(props) => (props.addTopMargin ? pxToRem(8) : 'none')};
  .tooltipStyle {
    box-shadow: 0 ${pxToRem(2)} ${pxToRem(20)} #ed116429;
    border: 0;
    border-radius: ${pxToRem(6)};
    margin-left: -8px;
    ${up('md')} {
      width: ${pxToRem(380)};
    }
  }
  ${up('md')} {
    left: ${pxToRem(160)};
    bottom: ${pxToRem(52)};
    margin-top: 0;
  }
`;

const ImageStyled = styled.img`
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};
  margin: 0 ${pxToRem(8)};
 // align-self: center;
  ${up('md')} {
    width: ${pxToRem(80)};
    height: ${pxToRem(48)};
  }
`;
